import React from 'react';

import {AppButton} from '@/components/Button';
import appContent from '@/services/content/appContent';
import appRouterService from '@/services/route/appRouterService';

import DeviceSettingLayout from '../../components/DeviceSettingLayout/DeviceSettingLayout';

const FirmwareInfo = () => {
    const {title, description, icon, continueButton, laterButton} = appContent.getUpdateFirmwareInfo();

    const handleOnContinueClick = () => {
        appRouterService.forwardToFirmwareNoticePage();
    };

    const handleOnLaterClick = () => {
        appRouterService.goBack();
    };

    return (
        <DeviceSettingLayout
            footer={
                <div className='flex w-full flex-col items-center gap-2'>
                    <AppButton
                        className='w-full'
                        primary
                        light
                        onClick={handleOnContinueClick}
                        alt={continueButton.alt}
                    >
                        {continueButton.text}
                    </AppButton>
                    <AppButton tertiary light onClick={handleOnLaterClick} alt={laterButton.alt}>
                        {laterButton.text}
                    </AppButton>
                </div>
            }
        >
            <DeviceSettingLayout.ContentHeader icon={icon} title={title} description={description} />
        </DeviceSettingLayout>
    );
};

export default FirmwareInfo;
